﻿import * as layerTypes from '../../../map/utils/layerTypes';
import * as paths from '../../../map/utils/paths';
import * as eventTypes from '../../../map/utils/eventTypes';
import * as classificationRows from '../../../map/utils/style/classificationRows';
import * as actionTypes from '../../utils/actionTypes';
import * as styleTypes from '../../../map/utils/style/styleTypes';
import StyleListControl from '../../../../StyleListControl/StyleListControl';
import StyleContol from '../../../../StyleControl/StyleControl';
import ChartConfigurator from '../chart/ChartConfigurator';
import Contextual from '../contextual/contextual';

export default class LegendControl {
    constructor(action, resourcesHandler, layerSettingsHandler, menuContainer, rootURL, classId, mapId, chartsControl, styleHandler, mapControl) {
        this.action = action;
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.menuContainer = menuContainer;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapId = mapId;
        this.chartsControl = chartsControl;
        this.styleHandler = styleHandler;
        this.mapControl = mapControl;
        this.elementId = 'map-action-' + this.classId + '-' + this.action.Id;
        this.legendElementId = 'legend-' + this.mapId + '-' + this.classId;
        this.legendResizerElementId = 'legend-resizer-' + this.classId + '-' + this.action.Id;
        this.legendCloseElementId = 'legend-close-' + this.classId + '-' + this.action.Id;
        this.legendSearchInputElementId = 'legend-search-input-' + this.classId + '-' + this.action.Id;
        this.legendSearchWrapperElementId = 'legend-search-wrapper-' + this.classId + '-' + this.action.Id;
        this.legendContentWrapperElementId = 'legend-content-wrapper-' + this.classId + '-' + this.action.Id;
        this.legendContentElementId = 'legend-content-' + this.classId + '-' + this.action.Id;
        this.legendCollapsePrefix = 'legend-collapse-' + this.classId + '-';
        this.legendSwitchPrefix = 'legend-switch-' + this.classId + '-';
        this.legendDetailsPrefix = 'legend-details-' + this.classId + '-';
        this.legendTitlePrefix = 'legend-title-' + this.classId + '-';
        this.legendGroupWrapperPrefix = 'legend-group-wrapper-' + this.classId + '-';
        this.legendLayerOpacityPrefix = 'legend-layer-opacity-' + this.classId + '-';
        this.legendLayerOptionsSwitchPrefix = 'legend-layer-options-switch-' + this.classId + '-';
        this.legendLayerOptionsWrapperPrefix = 'legend-layer-options-wrapper-' + this.classId + '-';
        this.legendLayerChartsWrapperPrefix = 'legend-layer-charts-wrapper-' + this.classId + '-';
        this.addNewChartButtonPrefix = 'add-new-chart-button-' + this.classId + '-';
        this.layerChartListWrapper = 'layer-chart-list-wrapper-' + this.classId + '-';
        this.styleWrapperPrefix = 'style-wrapper-' + this.classId + '-';
        this.legendLayerAdditionalOptionsPrefix = 'legend-layer-additional-options-' + this.classId + '-';
        this.legendLayerTooltipPrefix = 'legend-layer-tooltip-' + this.classId + '-';
        this.legendLayerSelectablePrefix = 'legend-layer-selectable-' + this.classId + '-';
        this.legendLayerFitPrefix = 'legend-layer-fit-' + this.classId + '-';
        this.legendLayerFilterPrefix = 'legend-layer-filter-' + this.classId + '-';
        this.legendModalHelper = 'legend-modal-helper-' + this.classId + '-' + this.action.Id;
        this.legendExtraModalHelper = 'legend-extra-modal-helper-' + this.classId + '-' + this.action.Id;
        this.legendFilterModalHelper = 'legend-filter-modal-helper-' + this.classId + '-' + this.action.Id;
        this.styleSettingsWrapper = 'legend-settings-wrapper-' + this.classId + '-' + this.action.Id;
        this.defaultStyleId = 'default-style-' + this.classId + '-' + this.action.Id + '-';
        this.highlightStyleId = 'highlight-style-' + this.classId + '-' + this.action.Id + '-';
        this.selectStyleId = 'select-style-' + this.classId + '-' + this.action.Id + '-';
        this.editDefaultStyle = 'switch-default-style-' + this.classId + '-' + this.action.Id + '-';
        this.editLegendChart = 'edit-legend-chart-' + this.classId + '-';
        this.titleLegendChart = 'title-legend-chart-' + this.classId + '-';
        this.legendChart = 'legend-chart-' + this.classId + '-';
        this.deleteLegendChart = 'delete-legend-chart-' + this.classId + '-';
        this.editHighlightStyle = 'switch-highlight-style-' + this.classId + '-' + this.action.Id + '-';
        this.editSelectStyle = 'switch-select-style-' + this.classId + '-' + this.action.Id + '-';
        this.styleSwitcherWrapper = 'style-switcher-wrapper-' + this.classId + '-' + this.action.Id;
        this.styleEditWrapper = 'style-edit-wrapper-' + this.classId + '-' + this.action.Id;
        this.styleSwitcherContainer = 'style-switcher-container-' + this.classId + '-' + this.action.Id;
        this.styleEditContainer = 'style-edit-container-' + this.classId + '-' + this.action.Id;
        this.cancelStyleSwitchId = 'cancel-style-switch-' + this.classId + '-' + this.action.Id;
        this.cancelStyleEditId = 'cancel-style-edit-' + this.classId + '-' + this.action.Id;
        this.applyStyleEditId = 'save-style-edit-' + this.classId + '-' + this.action.Id;
        this.cancelStyleSettingsId = 'cancel-style-settings-' + this.classId + '-' + this.action.Id;
        this.saveStyleSettingsId = 'save-style-settings-' + this.classId + '-' + this.action.Id;
        this.chartConfigurator = null;
        this.legendInitialized = false;
        this.generalActionControls = {};
        this.appliedFilter = {};
        this.swipeActive = false;
    }

    init() {
        this.menuContainer.append(this._getActionButtonTemplate());
        document.getElementById(this.elementId).addEventListener('click', this._actionButtonClickHandler());
        this._addEventHandlers();
    }

    handleTemplateBefore() {
        return '';
    }

    handleTemplateAfter() {
        return '';
    }

    handleExtra() {
        document.getElementsByClassName('style-keywords-group')[0].classList.remove('col-xl-3');
        document.getElementsByClassName('style-keywords-group')[0].classList.add('col-xl-6');
        document.getElementsByClassName('style-name-group')[0].classList.remove('col-xl-3');
        document.getElementsByClassName('style-name-group')[0].classList.add('col-xl-6');
        document.getElementsByClassName('style-filter-part')[0].classList.remove('mb-4');
    }

    addEventsForStyle(keyword, style) {
        document.querySelector('.style-item[data-ref="' + style.Id + '"][data-ref-key="' + keyword + '"]').addEventListener('click', (evt) => {
            let id = style.Id;

            if (this.switchStyleType == styleTypes.DEFAULT_STYLE_TYPE) {
                document.getElementById(this.defaultStyleId + this.switchStyleId).setAttribute('data-ref', id);
                document.querySelector('#' + this.defaultStyleId + this.switchStyleId + ' .style-config-img-wrapper').innerHTML = `<img src="` + (this.rootURL + paths.STYLE_PREVIEW_URL + id + '_0_preview.png' + `?cb=` + Date.now()) + `" class="style-config-preview"></img>`;
            } else if (this.switchStyleType == styleTypes.HOVER_STYLE_TYPE) {
                document.getElementById(this.highlightStyleId + this.switchStyleId).setAttribute('data-ref', id);
                document.querySelector('#' + this.highlightStyleId + this.switchStyleId + ' .style-config-img-wrapper').innerHTML = `<img src="` + (this.rootURL + paths.STYLE_PREVIEW_URL + id + '_0_preview.png' + `?cb=` + Date.now()) + `" class="style-config-preview"></img>`;
            } else if (this.switchStyleType == styleTypes.SELECT_STYLE_TYPE) {
                document.getElementById(this.selectStyleId + this.switchStyleId).setAttribute('data-ref', id);
                document.querySelector('#' + this.selectStyleId + this.switchStyleId + ' .style-config-img-wrapper').innerHTML = `<img src="` + (this.rootURL + paths.STYLE_PREVIEW_URL + id + '_0_preview.png' + `?cb=` + Date.now()) + `" class="style-config-preview"></img>`;
            }

            let newDefaultStyle = document.getElementById(this.defaultStyleId + this.switchStyleId).getAttribute('data-ref');
            let newHighlightStyle = document.getElementById(this.highlightStyleId + this.switchStyleId).getAttribute('data-ref');
            let newSelectStyle = document.getElementById(this.selectStyleId + this.switchStyleId).getAttribute('data-ref');


            $event.notify(eventTypes.LAYER_STYLE_CHANGED, {
                layerId: this.switchStyleId, styles: {
                    defaultStyle: newDefaultStyle,
                    highlightStyle: newHighlightStyle,
                    selectStyle: newSelectStyle
                }
            }, this, this.classId);

            this.styleHandler.loadStyle(newDefaultStyle).then(() => {
                this.mapControl.layerHandler.changeLayerStyle(this.switchStyleId).then(() => {
                    this._rebuildLayerLegendNode(this.switchStyleId, newDefaultStyle);
                    document.getElementById(this.legendExtraModalHelper).innerHTML = '';
                });
            });
        });
    }

    // reconstruieste nodul din legenda al unui layer dupa schimbarea/editarea stilului default:
    // clasificarile noi (tematic/categorial) inlocuiesc randurile vechi, altfel revine la previzualizarea simpla
    _rebuildLayerLegendNode(layerId, defaultStyleId) {
        let layer = this.layerSettingsHandler.getLayerSettings(layerId);

        if (layer == null) {
            return;
        }

        let classification = this._getClassificationsForLayer(layer);

        if (classification != null && classification.length > 0) {
            layer.hasClassification = true;
            layer.classifications = classification;
            let parentNode = document.querySelector('.legend-layer-wrapper[data-id="' + layerId + '"]');

            if (parentNode == null) {
                return;
            }

            if (!parentNode.parentElement.classList.contains('legend-layer-classifications')) {
                parentNode.classList.add('legend-layer-classifications');
                parentNode.classList.add('legend-group-layer');
                parentNode.classList.remove('legend-layer-wrapper');
            } else {
                parentNode = parentNode.parentElement;
            }

            parentNode.innerHTML = this._getLegendLayerWithClassificationsContentTemplate(layer, classification);
            this._addLayerHandlers(layer);
            this.layerSettingsHandler.addConfigForLayer(layer, this);
        } else {
            layer.hasClassification = false;
            layer.classifications = null;
            let baseNode = document.querySelector('.legend-layer-wrapper[data-id="' + layerId + '"]');

            if (baseNode == null) {
                return;
            }

            let parentNode = baseNode.parentElement;
            if (parentNode.classList.contains('legend-layer-classifications')) {
                parentNode.classList.remove('legend-layer-classifications');
                parentNode.classList.remove('legend-group-layer');
                parentNode.classList.add('legend-layer-wrapper');
                parentNode.innerHTML = this._getLegendLayerTemplate(layer, true);
                this._addLayerHandlers(layer);
                this.layerSettingsHandler.addConfigForLayer(layer, this);
            } else {
                if (defaultStyleId != null) {
                    document.querySelector('.legend-layer-wrapper[data-id="' + layerId + '"] .legend-layer-preview').innerHTML = `<img class="legend-preview-image" src="` + (this.rootURL + paths.LAYER_PREVIEW_URL.replaceAll('{id}', defaultStyleId).replaceAll('{rule}', 0)) + `?cb=${Date.now()}` + `"></img>`;
                }
            }
        }
    }

    _addEventHandlers() {
        $event.register(eventTypes.LAYER_ADDED, this._getLayerAddedHandler(), this, this.classId);
        $event.register(eventTypes.LAYER_EDITED, this._getLayerEditedHandler(), this, this.classId);
        $event.register(eventTypes.THEMATIC_CLASSIFICATION_UPDATED, this._getThematicClassificationUpdatedHandler(), this, this.classId);
        $event.register(eventTypes.CHART_ADDED, this._getChartAddedHandler(), this, this.classId);
        $event.register(eventTypes.CHART_UPDATED, this._getChartUpdatedHandler(), this, this.classId);
        $event.register(eventTypes.LAYER_VISIBILITY_CHANGED, this._getLayerVisibilityChangedHandler(), this, this.classId);

        $('body').on('mouseup', () => {
            if (this.swipeActive) {
                this.swipeActive = false;
                this._enableSelection();
            }
        });
    }

    _disableSelection(scope = document.body) {
        scope.classList.add('no-select');
        scope.addEventListener('selectstart', this._prevent, { capture: true });
        scope.addEventListener('dragstart', this._prevent, { capture: true });
    }

    _enableSelection(scope = document.body) {
        scope.classList.remove('no-select');
        scope.removeEventListener('selectstart', this._prevent, { capture: true });
        scope.removeEventListener('dragstart', this._prevent, { capture: true });
        //const sel = window.getSelection?.();
        //sel && sel.removeAllRanges();
    }

    //CG: cand un layer e aprins din afara legendei (Add, QuickAdd, showFeature), comutatorul lui ramanea pe off
    _getLayerVisibilityChangedHandler() {
        return (eventName, data, sender) => {
            if (sender === this || data == null) {
                return;
            }

            this._syncLayerVisibility(data.layerId, data.visible);
        };
    }

    //CG: aliniaza comutatorul, clasificarile si parintii ca la bifarea din legenda, fara sa renotifice layerul insusi
    _syncLayerVisibility(layerId, visible) {
        let layer = this.layerSettingsHandler.getLayerSettings(layerId);
        let layerSwitch = $("#" + this.legendSwitchPrefix + layerId).data('kendoSwitch');

        if (layer == null || layerSwitch == null || layerSwitch.check() == visible) {
            return;
        }

        layerSwitch.check(visible);

        if (layer.hasClassification) {
            layer.classifications.forEach(classification => {
                this._handleClassificationLayerVisibility(layer, classification, visible, true);
            });
        }

        this._handleParentsVisibility(layer, visible);
    }

    _getLayerAddedHandler() {
        var handler = (eventName, data, sender) => {
            if (this.legendInitialized) {
                this._constructLegend(data.hide);
                $event.notify(eventTypes.LEGEND_INITIALIZED, null, this, this.classId);
            }
        };

        return handler;
    }

    _getLayerEditedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null) {
                switch (data.layer.Type) {
                    case layerTypes.GROUP: this._handleGroupEdited(data.layer);
                        break;
                    case layerTypes.GEOSERVICE: this._handleGeoserviceEdited(data.layer);
                        break;
                    case layerTypes.ENTITY: this._handleEntityEdited(data.layer);
                        break;
                    default: break;
                }
            }
        };

        return handler;
    }

    // clasificarea tematica (graduala/categoriala) s-a calculat la runtime dupa incarcarea feature-urilor
    // (analize XpQuery / WFS_ALL) => reconstruim nodul din legenda ca sa reflecte clasele reale
    _getThematicClassificationUpdatedHandler() {
        var handler = (eventName, data, sender) => {
            if (data == null || data.layerId == null || !this.legendInitialized) {
                return;
            }

            let layer = this.layerSettingsHandler.getLayerSettings(data.layerId);

            if (layer == null || document.querySelector('.legend-layer-wrapper[data-id="' + data.layerId + '"]') == null) {
                return;
            }

            this._rebuildLayerLegendNode(data.layerId, layer.IdDefaultStyle);
        };

        return handler;
    }

    _getChartUpdatedHandler() {
        var handler = (eventName, data, sender) => {
            let chart = data.chart;
            $('#' + this.titleLegendChart + chart.id)[0].innerText = chart.title;
        };

        return handler;
    }

    _getChartAddedHandler() {
        var handler = (eventName, data, sender) => {
            let chart = data.chart;
            let layer = this.layerSettingsHandler.getLayerSettings(data.layerId);
            let template = `<div class="legend-chart-row mb-3" id="` + this.legendChart + chart.id + `">
                    <span id="` + this.titleLegendChart + chart.id + `">` + chart.title + `</span>
                    <span style="margin-top: -3px;" title="` + this.resourcesHandler.get('EditChart') + `" class="fal fa-pencil-alt btn btn-primary edit-chart-btn" id="` + this.editLegendChart + chart.id + `"></span>
                    <span style="margin-top: -3px; padding-left: 0.25rem !important; padding-right: 0.25rem !important;" title="` + this.resourcesHandler.get('DeleteChart') + `" class="fal fa-times btn btn-danger edit-chart-btn" id="` + this.deleteLegendChart + chart.id + `"></span>
                    </div>`;

            $('#' + this.layerChartListWrapper + layer.Id).append(template);
            this._addChartEvents(layer, chart.id);
        };

        return handler;
    }

    _handleGroupEdited(group) {
        document.getElementById(this.legendTitlePrefix + group.Id).innerHTML = group.Title;
    }

    _handleGeoserviceEdited(geoservice) {
        if (geoservice.hasClassification) {
            let legendNode = document.querySelector('.legend-layer-wrapper[data-id="' + geoservice.Id + '"]').parentElement;
            legendNode.innerHTML = this._getLegendLayerWithClassificationsContentTemplate(geoservice, geoservice.classifications);
        } else {
            let legendNode = document.querySelector('.legend-layer-wrapper[data-id="' + geoservice.Id + '"]');
            legendNode.innerHTML = this._getLegendLayerTemplate(geoservice);
        }

        this._addLayerHandlers(geoservice);
        $event.notify(eventTypes.LEGEND_LAYER_RECREATED, { layerId: geoservice.Id }, this, this.classId);
    }

    _handleEntityEdited(entity) {
        if (entity.hasClassification) {
            let legendNode = document.querySelector('.legend-layer-wrapper[data-id="' + entity.Id + '"]').parentElement;
            legendNode.innerHTML = this._getLegendLayerWithClassificationsContentTemplate(entity, entity.classifications);
        } else {
            let legendNode = document.querySelector('.legend-layer-wrapper[data-id="' + entity.Id + '"]');
            legendNode.innerHTML = this._getLegendLayerTemplate(entity);
        }

        this._addLayerHandlers(entity);
        $event.notify(eventTypes.LEGEND_LAYER_RECREATED, { layerId: entity.Id }, this, this.classId);
    }

    _actionButtonClickHandler() {
        return () => {
            if (this.legendInitialized) {
                if (document.getElementById(this.legendElementId).classList.contains('show')) {
                    document.getElementById(this.legendElementId).classList.remove('show');
                    document.getElementById(this.legendElementId).style.display = 'none';
                    this._notifyVisibility(false);
                    $('#' + this.elementId).removeClass('selected');
                } else {
                    document.getElementById(this.legendElementId).classList.add('show');
                    document.getElementById(this.legendElementId).style.display = 'block';
                    this._notifyVisibility(true);
                    $('#' + this.elementId).addClass('selected');
                }
            } else {
                this._constructLegend();
                this.legendInitialized = true;
                $event.notify(eventTypes.LEGEND_INITIALIZED, null, this, this.classId);
                this._notifyVisibility(true);
                $('#' + this.elementId).addClass('selected');
            }
        }
    }

    _constructLegend(hide) {
        let mapContainer = this.menuContainer.parentElement.parentElement;

        if (document.getElementById(this.legendElementId) != null) {
            document.getElementById(this.legendElementId).remove();
        }

        mapContainer.append(this._getLegendTemplate());
        mapContainer.append(this._getModalTemplate());
        mapContainer.append(this._getExtraModalTemplate());
        mapContainer.append(this._getFilterModalTemplate());

        if (!hide) {
            document.getElementById(this.legendElementId).classList.add('show');
        }

        this._addLayers();
        this._addLegendHandlers();
        this._addLayersHandlers(this.layerSettingsHandler.layers);
        document.getElementById(this.legendCloseElementId).addEventListener('click', () => {
            document.getElementById(this.legendElementId).classList.remove('show');
            document.getElementById(this.legendElementId).style.display = 'none';
            this._notifyVisibility(false);
            $('#' + this.elementId).removeClass('selected');
        });

        $('#' + this.legendResizerElementId).on('mousedown', (evt) => {
            this.swipeActive = true;
            this._disableSelection();
        });

        $('body').on('mousemove', (evt) => {
            if (this.swipeActive) {
                let currentPosition = evt.originalEvent.clientX;

                let legendRight = $('#' + this.legendElementId)[0].getBoundingClientRect().right;

                if (currentPosition < legendRight) {
                    let width = legendRight - currentPosition;
                    $('#' + this.legendElementId).css('width', width + 'px');
                    $('#' + this.legendElementId).css('max-width', width + 'px');
                    $('#' + this.legendElementId).css('min-width', width + 'px');
                }
            }
        });
    }

    _addLegendHandlers() {
        document.getElementById(this.legendSearchInputElementId).addEventListener('keyup', (evt) => {
            let value = evt.currentTarget.value;
            this._filterLayers(this.layerSettingsHandler.layers, value);
        });

        document.getElementById(this.legendContentElementId).addEventListener('drop', (evt) => {
            this._dropLegendNode(evt);
        });

        document.getElementById(this.legendContentElementId).addEventListener('dragover', (evt) => {
            this._allowDropLegendNode(evt);
        });
    }

    _filterLayers(layers, value) {
        if (layers != null && layers.length > 0) {
            layers.forEach(layer => {
                if (layer.Type == layerTypes.GROUP) {
                    this._filterLayers(layer.Items, value);

                    let layerElement = document.querySelector('.legend-layer-wrapper[data-id="' + layer.Id + '"]');
                    let groupWrapperElement = document.querySelector('.legend-group-layer[data-id="' + layer.Id + '"]');
                    if ((layer.Title != null && layer.Title.toLowerCase().indexOf(value.toLowerCase()) >= 0) || value == null || value.trim() == '') {
                        layerElement.style.display = 'block';
                        layerElement.setAttribute('hidden-by-filter', '0');
                        groupWrapperElement.style.display = 'block';
                        groupWrapperElement.setAttribute('hidden-by-filter', '0');
                    } else {
                        let visibleChildren = document.querySelectorAll('.legend-group-layer[data-id="' + layer.Id + '"] [hidden-by-filter="0"]:not([data-id="' + layer.Id + '"])');

                        if (visibleChildren.length > 0) {
                            layerElement.style.display = 'block';
                            layerElement.setAttribute('hidden-by-filter', '0');
                            groupWrapperElement.style.display = 'block';
                            groupWrapperElement.setAttribute('hidden-by-filter', '0');
                        } else {
                            layerElement.style.display = 'none';
                            layerElement.setAttribute('hidden-by-filter', '1');
                            groupWrapperElement.style.display = 'none';
                            groupWrapperElement.setAttribute('hidden-by-filter', '1');
                        }
                    }
                } else {
                    let layerElement = document.querySelector('.legend-layer-wrapper[data-id="' + layer.Id + '"]');
                    if ((layer.Title != null && layer.Title.toLowerCase().indexOf(value.toLowerCase()) >= 0) || value == null || value.trim() == '') {
                        layerElement.style.display = 'block';
                        layerElement.setAttribute('hidden-by-filter', '0');

                        if (layer.hasClassification && layer.classifications != null) {
                            layer.classifications.forEach(classification => {
                                let classifItem = document.querySelector('.legend-layer-wrapper[data-id="' + layer.Id + '-' + classification.idx + '"]');
                                if (classifItem == null) {
                                    return;
                                }
                                let cname = classification.name != null ? String(classification.name).toLowerCase() : '';
                                if (cname.indexOf(value.toLowerCase()) >= 0 || value == null || value.trim() == '') {
                                    classifItem.style.display = 'block';
                                    classifItem.setAttribute('hidden-by-filter', '0');
                                } else {
                                    classifItem.style.display = 'none';
                                    classifItem.setAttribute('hidden-by-filter', '1');
                                }
                            });
                        }
                    } else {
                        if (layer.hasClassification && layer.classifications != null) {
                            let visibileChildren = false;

                            layer.classifications.forEach(classification => {
                                let classifItem = document.querySelector('.legend-layer-wrapper[data-id="' + layer.Id + '-' + classification.idx + '"]');
                                if (classifItem == null) {
                                    return;
                                }
                                let cname = classification.name != null ? String(classification.name).toLowerCase() : '';
                                if (cname.indexOf(value.toLowerCase()) >= 0 || value == null || value.trim() == '') {
                                    visibileChildren = true;
                                    classifItem.style.display = 'block';
                                    classifItem.setAttribute('hidden-by-filter', '0');
                                } else {
                                    classifItem.style.display = 'none';
                                    classifItem.setAttribute('hidden-by-filter', '1');
                                }
                            });

                            if (visibileChildren) {
                                layerElement.style.display = 'block';
                                layerElement.setAttribute('hidden-by-filter', '0');
                            } else {
                                layerElement.style.display = 'none';
                                layerElement.setAttribute('hidden-by-filter', '1');
                            }
                        } else {
                            layerElement.style.display = 'none';
                            layerElement.setAttribute('hidden-by-filter', '1');
                        }
                    }
                }
            });
        }
    }

    _addLayersHandlers(layers) {
        if (layers && layers.length > 0) {
            for (let i = 0; i < layers.length; i++) {
                let layer = layers[i];
                this._addLayerHandlers(layer);
                if (layer.Type == layerTypes.GROUP) {
                    this._addLayersHandlers(layer.Items);
                }
            }
        }
    }

    _addLayerHandlers(layer) {
        this._addLayerVisibilityHandler(layer);
        this._addLayerSelectableHandler(layer);
        this._addLayerOpacityHandler(layer);
        this._addLayerFitHandler(layer);
        this._addLayerFilterHandler(layer);
        this._addLayerAction(layer);

        if (layer.hasClassification) {
            this._addClassificationLayerVisibilityHandler(layer);
        }

        if (layer.Type == layerTypes.GROUP) {
            document.getElementById(this.legendCollapsePrefix + layer.Id).addEventListener('click', (evt) => {
                if (evt.currentTarget.classList.contains('k-i-collapse')) {
                    evt.currentTarget.classList.remove('k-i-collapse');
                    evt.currentTarget.classList.remove('ni');
                    evt.currentTarget.classList.remove('ni-chevron-up');

                    evt.currentTarget.classList.add('k-i-expand');
                    evt.currentTarget.classList.add('ni');
                    evt.currentTarget.classList.add('ni-chevron-down');

                    document.getElementById(this.legendGroupWrapperPrefix + layer.Id).classList.remove('show');
                    document.getElementById(this.legendGroupWrapperPrefix + layer.Id).classList.add('hide');
                } else {
                    evt.currentTarget.classList.remove('k-i-expand');
                    evt.currentTarget.classList.remove('ni');
                    evt.currentTarget.classList.remove('ni-chevron-down');

                    evt.currentTarget.classList.add('k-i-collapse');
                    evt.currentTarget.classList.add('ni');
                    evt.currentTarget.classList.add('ni-chevron-up');

                    document.getElementById(this.legendGroupWrapperPrefix + layer.Id).classList.remove('hide');
                    document.getElementById(this.legendGroupWrapperPrefix + layer.Id).classList.add('show');
                }
            });

            document.getElementById(this.legendDetailsPrefix + layer.Id).addEventListener('dragstart', (evt) => {
                this._dragLegendNode(evt);
            });

            document.getElementById(this.legendGroupWrapperPrefix + layer.Id).addEventListener('drop', (evt) => {
                this._dropLegendNode(evt);
            });

            document.getElementById(this.legendGroupWrapperPrefix + layer.Id).addEventListener('dragover', (evt) => {
                this._allowDropLegendNode(evt);
            });
        } else {
            if (layer.hasClassification) {
                document.getElementById(this.legendCollapsePrefix + layer.Id).addEventListener('click', (evt) => {
                    if (evt.currentTarget.classList.contains('k-i-collapse')) {
                        evt.currentTarget.classList.remove('k-i-collapse');
                        evt.currentTarget.classList.remove('ni');
                        evt.currentTarget.classList.remove('ni-chevron-up');

                        evt.currentTarget.classList.add('k-i-expand');
                        evt.currentTarget.classList.add('ni');
                        evt.currentTarget.classList.add('ni-chevron-down');

                        document.getElementById(this.legendGroupWrapperPrefix + layer.Id).classList.remove('show');
                        document.getElementById(this.legendGroupWrapperPrefix + layer.Id).classList.add('hide');
                    } else {
                        evt.currentTarget.classList.remove('k-i-expand');
                        evt.currentTarget.classList.remove('ni');
                        evt.currentTarget.classList.remove('ni-chevron-down');

                        evt.currentTarget.classList.add('k-i-collapse');
                        evt.currentTarget.classList.add('ni');
                        evt.currentTarget.classList.add('ni-chevron-up');

                        document.getElementById(this.legendGroupWrapperPrefix + layer.Id).classList.remove('hide');
                        document.getElementById(this.legendGroupWrapperPrefix + layer.Id).classList.add('show');
                    }
                });
            }

            document.getElementById(this.legendLayerOptionsSwitchPrefix + layer.Id).addEventListener('click', (evt) => {
                if (document.getElementById(this.legendLayerOptionsSwitchPrefix + layer.Id).classList.contains('k-i-expand')) {
                    document.getElementById(this.legendLayerOptionsSwitchPrefix + layer.Id).classList.remove('k-i-expand');
                    document.getElementById(this.legendLayerOptionsSwitchPrefix + layer.Id).classList.remove('ni');
                    document.getElementById(this.legendLayerOptionsSwitchPrefix + layer.Id).classList.remove('ni-chevron-down');

                    document.getElementById(this.legendLayerOptionsSwitchPrefix + layer.Id).classList.add('k-i-collapse');
                    document.getElementById(this.legendLayerOptionsSwitchPrefix + layer.Id).classList.add('ni');
                    document.getElementById(this.legendLayerOptionsSwitchPrefix + layer.Id).classList.add('ni-chevron-up');
                    this._showLayerOptions(layer);
                } else {
                    document.getElementById(this.legendLayerOptionsSwitchPrefix + layer.Id).classList.remove('k-i-collapse');
                    document.getElementById(this.legendLayerOptionsSwitchPrefix + layer.Id).classList.remove('ni');
                    document.getElementById(this.legendLayerOptionsSwitchPrefix + layer.Id).classList.remove('ni-chevron-up');

                    document.getElementById(this.legendLayerOptionsSwitchPrefix + layer.Id).classList.add('k-i-expand');
                    document.getElementById(this.legendLayerOptionsSwitchPrefix + layer.Id).classList.add('ni');
                    document.getElementById(this.legendLayerOptionsSwitchPrefix + layer.Id).classList.add('ni-chevron-down');
                    this._hideLayerOptions(layer);
                }
            });

            document.getElementById(this.legendDetailsPrefix + layer.Id).addEventListener('dragstart', (evt) => {
                this._dragLegendNode(evt);
            });
        }
    }

    _showLayerOptions(layer) {
        let template = `<div class="layer-option-container pt-1 pr-1 pl-1 mb-3">
                            <label class="form-label">` + this.resourcesHandler.get('Opacity') + `:</label>
                            <input type="range" min="1" max="100" value="` + (layer.Opacity * 100) + `" class="layer-opacity-slider" id="` + (this.legendLayerOpacityPrefix + layer.Id) + `">
                        </div>`;

        if (layer.Id != layerTypes.REDLINE && layer.Id != layerTypes.DIMENSIONING && layer.Id != layerTypes.MEASUREMENTS
            && layer.Type != layerTypes.GROUP && (layer.Type == layerTypes.XP_NATIVE || layer.Type == layerTypes.ENTITY || (layer.Type == layerTypes.GEOSERVICE && layer.Interpretation == layerTypes.WFS) || layer.Type == layerTypes.TEMPORARY_VECTOR)) {
            template += `<div class="style-option-container pt-1 pr-1 pl-1 form-row mb-3" id="` + (this.styleWrapperPrefix + layer.Id) + `">
                </div>`;

            template += `<div class="layer-option-container pt-1 pr-1 pl-1 form-row">
                <label class="form-label col-12">` + this.resourcesHandler.get('Charts') + `:
                    <button class="btn btn-primary fal fa-plus-hexagon legend-suboption" id="` + (this.addNewChartButtonPrefix + layer.Id) + `"></button></label>
                    <div class="legend-charts-wrapper" id="` + this.layerChartListWrapper + layer.Id + `">`;

            if (layer.Charts != null) {
                let charts = Object.keys(layer.Charts);

                charts.forEach(chartId => {
                    let chart = layer.Charts[chartId];
                    template += `<div class="legend-chart-row mb-3" id="` + this.legendChart + chartId + `">
                    <span id="` + this.titleLegendChart + chart.id + `">` + chart.title + `</span>
                    <span style="margin-top: -3px;" title="` + this.resourcesHandler.get('EditChart') + `" class="fal fa-pencil-alt btn btn-primary edit-chart-btn" id="` + this.editLegendChart + chartId + `"></span>
                    <span style="margin-top: -3px; padding-left: 0.25rem !important; padding-right: 0.25rem !important;" title="` + this.resourcesHandler.get('DeleteChart') + `" class="fal fa-times btn btn-danger edit-chart-btn" id="` + this.deleteLegendChart + chartId + `"></span>
                    </div>`;
                });
            }

            template += `</div>
                <div class="layer-chart-settings col-10 ml-auto" id="` + (this.legendLayerChartsWrapperPrefix + layer.Id) + `"></div>
            </div>`;
        }

        $('#' + this.legendLayerOptionsWrapperPrefix + layer.Id)[0].innerHTML = template;
        $('#' + this.legendLayerOptionsWrapperPrefix + layer.Id)[0].classList.remove('hide');
        $('#' + this.legendLayerOptionsWrapperPrefix + layer.Id)[0].classList.add('show');
        document.getElementById(this.legendLayerOptionsSwitchPrefix + layer.Id).parentElement.parentElement.classList.add('options-selected');

        if (layer.Id != layerTypes.REDLINE && layer.Id != layerTypes.DIMENSIONING && layer.Id != layerTypes.MEASUREMENTS
            && layer.Type != layerTypes.GROUP && (layer.Type == layerTypes.XP_NATIVE || layer.Type == layerTypes.ENTITY || (layer.Type == layerTypes.GEOSERVICE && layer.Interpretation == layerTypes.WFS) || layer.Type == layerTypes.TEMPORARY_VECTOR)) {
            this._initStyles(layer);
        }

        this._addNewChartHandler(layer);
        this._addLayerOpacityHandler(layer);
    }

    toggleSelection(layerId, trigger) {
        let layer = this.layerSettingsHandler.getLayerSettings(layerId);
        this._handleLayerVisibility(layer, true, trigger);
    }

    _hideLayerOptions(layer) {
        $('#' + this.legendLayerOptionsWrapperPrefix + layer.Id)[0].innerHTML = '';
        $('#' + this.legendLayerOptionsWrapperPrefix + layer.Id)[0].classList.remove('show');
        $('#' + this.legendLayerOptionsWrapperPrefix + layer.Id)[0].classList.add('hide');
        document.getElementById(this.legendLayerOptionsSwitchPrefix + layer.Id).parentElement.parentElement.classList.remove('options-selected');
    }

    _initStyles(layer) {
        document.getElementById(this.styleWrapperPrefix + layer.Id).innerHTML = this._getStyleSettingsTemplate(layer);

        let idDefaultStyle = layer.IdDefaultStyle;
        let idHighlightStyle = layer.IdHighlightStyle;
        let idSelectStyle = layer.IdSelectStyle;

        if (idDefaultStyle != null) {
            document.getElementById(this.defaultStyleId + layer.Id).setAttribute('data-ref', idDefaultStyle);
            this._setStylePreview(this.defaultStyleId + layer.Id, idDefaultStyle);
        }

        if (idHighlightStyle != null) {
            document.getElementById(this.highlightStyleId + layer.Id).setAttribute('data-ref', idHighlightStyle);
            this._setStylePreview(this.highlightStyleId + layer.Id, idHighlightStyle);
        }

        if (idSelectStyle != null) {
            document.getElementById(this.selectStyleId + layer.Id).setAttribute('data-ref', idSelectStyle);
            this._setStylePreview(this.selectStyleId + layer.Id, idSelectStyle);
        }

        document.querySelector('#' + this.defaultStyleId + layer.Id + ' .style-config-img-wrapper').addEventListener('click', () => {
            this._handleSwitchStyle(styleTypes.DEFAULT_STYLE_TYPE, layer);
        });

        document.getElementById(this.editDefaultStyle + layer.Id).addEventListener('click', () => {
            this._handleEditStyle(document.getElementById(this.defaultStyleId + layer.Id).getAttribute('data-ref'), styleTypes.DEFAULT_STYLE_TYPE, layer);
        });

        document.querySelector('#' + this.highlightStyleId + layer.Id + ' .style-config-img-wrapper').addEventListener('click', () => {
            this._handleSwitchStyle(styleTypes.HOVER_STYLE_TYPE, layer);
        });

        document.getElementById(this.editHighlightStyle + layer.Id).addEventListener('click', () => {
            this._handleEditStyle(document.getElementById(this.highlightStyleId + layer.Id).getAttribute('data-ref'), styleTypes.HOVER_STYLE_TYPE, layer);
        });

        document.querySelector('#' + this.selectStyleId + layer.Id + ' .style-config-img-wrapper').addEventListener('click', () => {
            this._handleSwitchStyle(styleTypes.SELECT_STYLE_TYPE, layer);
        });

        document.getElementById(this.editSelectStyle + layer.Id).addEventListener('click', () => {
            this._handleEditStyle(document.getElementById(this.selectStyleId + layer.Id).getAttribute('data-ref'), styleTypes.SELECT_STYLE_TYPE, layer);
        });
    }

    // Stilurile de sistem ('sys_N') nu au preview salvat sub acest id, ci sub id-ul real din baza.
    // Daca nu se poate rezolva, lasam placeholder-ul gol in loc de o imagine rupta.
    _setStylePreview(containerId, idStyle) {
        let idPreview = ('' + idStyle).indexOf('sys_') == 0 ? this.styleHandler.systemStyles[idStyle] : idStyle;

        if (idPreview == null) {
            return;
        }

        document.querySelector('#' + containerId + ' .style-config-img-wrapper').innerHTML = `<img title="` + this.resourcesHandler.get('EditStyle') + `" src="` + (this.rootURL + paths.STYLE_PREVIEW_URL + idPreview + '_0_preview.png' + `?cb=` + Date.now()) + `" class="style-config-preview"></img>`;
    }

    _handleEditStyle(idStyle, styleType, layer) {
        let style = this.styleHandler.getCombinedStyle(idStyle);

        if (style.style.Type == null || style.style.Type.trim() == '') {
            style.style.Type = 'CLASIC';
        }

        this.editStyleId = layer.Id;

        document.getElementById(this.legendExtraModalHelper).innerHTML = this._getStyleEditTemplate(style.style.Type);

        if (style.style.Type != 'CLASIC') {
            let additional = {};

            if (layer.Entity != null) {
                additional.idEntity = layer.Entity.Id;

                if (layer.Entity.Type == 2) {
                    let fields = [];

                    layer.Entity.outputValues.forEach(field => {
                        fields.push({
                            FieldName: field.outputName,
                            Id: field.outputName,
                            Name: field.outputName
                        });
                    });
                    additional.fields = fields
                }
            } else if (layer.Geoservice != null) {
                additional.idEntity = layer.Geoservice.Id;
                additional.Type = 'Geoservice';
            }

            this.styleControl = new StyleContol(document.getElementById(this.styleEditContainer), this.rootURL, JSON.stringify(style.style), style.type, this.resourcesHandler, additional);
        } else {
            $('.general-settings-panel').css('width', '80vw');
            $('#' + this.styleEditContainer).removeClass('pt-3');
            $('#' + this.styleEditContainer).removeClass('pl-3');
            $('#' + this.styleEditContainer).removeClass('pr-3');
            window.existingJoRules = this.styleHandler.styles[idStyle];
            $.pjax({ push: false, url: this.rootURL + paths.CLASSIC_STYLE_SETTINGS_URL + idStyle, container: '#' + this.styleEditContainer, timeout: 10000, contentType: 'application/json' })
        }

        document.getElementById(this.cancelStyleEditId).addEventListener('click', () => {
            window.existingJoRules = null;
            document.getElementById(this.legendExtraModalHelper).innerHTML = '';
        });

        document.getElementById(this.applyStyleEditId).addEventListener('click', () => {
            let newStyle;
            if (style.style.Type == 'CLASIC') {
                newStyle = saveClassicStyleRuleChanges();
                window.existingJoRules = null;
            } else {
                newStyle = this.styleControl.save();
            }

            this.styleHandler.applyStyle(idStyle, newStyle);

            this.mapControl.layerHandler.changeLayerStyle(this.editStyleId).then(() => {
                // editarea stilului default poate schimba clasificarile (ex. categorial -> gradual) => reconstruim nodul din legenda
                if (styleType == styleTypes.DEFAULT_STYLE_TYPE) {
                    this._rebuildLayerLegendNode(this.editStyleId, layer.IdDefaultStyle);
                }
                document.getElementById(this.legendExtraModalHelper).innerHTML = '';
            });

            //$event.notify(eventTypes.LAYER_STYLE_MODIFIED, {
            //    layerId: this.editStyleId
            //}, this, this.classId);
        });
    }

    _handleSwitchStyle(styleType, layer) {
        document.getElementById(this.legendExtraModalHelper).innerHTML = this._getStyleSwitcherTemplate();

        let styleListControl = new StyleListControl(document.getElementById(this.styleSwitcherContainer), this.rootURL, this);
        this.switchStyleType = styleType;
        this.switchStyleId = layer.Id;

        document.getElementById(this.cancelStyleSwitchId).addEventListener('click', () => {
            document.getElementById(this.legendExtraModalHelper).innerHTML = '';
        });
    }

    _addLayerSelectableHandler(layer) {
        let element = document.getElementById(this.legendLayerSelectablePrefix + layer.Id);

        if (element != null) {
            element.addEventListener('click', (evt) => {
                if (layer.Selectable) {
                    element.classList.remove('btn-primary');
                    element.classList.add('btn-secondary');
                    $event.notify(eventTypes.LAYER_SELECTABILITY_CHANGED, { layerId: layer.Id, selectable: false }, this, this.classId);
                } else {
                    element.classList.remove('btn-secondary');
                    element.classList.add('btn-primary');
                    $event.notify(eventTypes.LAYER_SELECTABILITY_CHANGED, { layerId: layer.Id, selectable: true }, this, this.classId);
                }
            });
        }
    }

    _addLayerAction(layer) {
        let items = $('.action-button-' + layer.Id);

        if (items.length > 0) {
            items.on('click', (evt) => {
                this._handleLayerAction(layer, evt);
            });
        }
    }

    _handleLayerAction(layer, evt) {
        evt.preventDefault();
        evt.stopPropagation();
        let action = this.mapControl.generalActionSettingsHandler.settings.find(x => x.Id == evt.currentTarget.getAttribute('action-id'));

        if (action) {
            if (action.SubType == actionTypes.SUBTYPE_GROUP) {
                this._showLayerActionGroup(action, layer, evt);
            } else {
                this._executeLayerAction(action, evt);
            }
        }
    }

    _executeLayerAction(action, evt) {
        switch (action.Type) {
            case actionTypes.TYPE_STANDARD_GENERAL: this._initStandardGeneralAction(action, evt);
                break;
            case actionTypes.TYPE_DYNAMIC_GENERAL: this._initDynamicGeneralAction(action);
                break;
            default: break;
        }
    }

    _showLayerActionGroup(action, layer, evt) {
        let items = this._getLayerActionMenuItems(action.Items || [], layer, evt);
        if (items.length == 0) {
            return;
        }

        this.contextMenu = new Contextual({
            isSticky: false,
            minWidth: '150px',
            width: 'auto',
            target: null,
            owner: this,
            event: evt,
            items: items
        });
    }

    _getLayerActionMenuItems(actions, layer, evt) {
        let items = [];

        actions.forEach(action => {
            if (action.SubType == actionTypes.SUBTYPE_SEPARATOR) {
                items.push({ type: 'seperator' });
            } else if (action.SubType == actionTypes.SUBTYPE_GROUP) {
                let children = this._getLayerActionMenuItems(action.Items || [], layer, evt);
                if (children.length > 0) {
                    items.push({
                        type: 'submenu',
                        label: this._getLayerActionLabel(action),
                        cssIcon: action.Icon || '',
                        items: children
                    });
                }
            } else {
                items.push({
                    label: this._getLayerActionLabel(action),
                    cssIcon: action.Icon || '',
                    onClick: () => this._executeLayerAction(action, evt)
                });
            }
        });

        return items;
    }

    _getLayerActionLabel(action) {
        let text = action.Text != null ? action.Text.toString().trim() : '';
        if (text != '' && text != action.SubType) {
            return this.resourcesHandler.get(text);
        }
        if (action.Title != null && action.Title.toString().trim() != '') {
            return action.Title;
        }
        return this.resourcesHandler.get('ActionSubType_' + action.SubType);
    }

    _initStandardGeneralAction(action, evt) {
        switch (action.SubType) {
            case actionTypes.SUBTYPE_ADD: this._handleAddControl(action, evt);
                break;
            default: break;
        }
    }

    _handleAddControl(action, evt) {
        let layer = this.mapControl.layerHandler.getLayerById(action.IdMapLayer)[0];
        //CG: layerul poate lipsi de pe harta (incarcare esuata, recreare dupa schimbarea stilului)
        if (layer == null) {
            toastr.warning(this.resourcesHandler.get('AddFeatureLayerUnavailable'));
            return;
        }

        if (!layer.isVisible()) {
            $event.notify(eventTypes.LAYER_VISIBILITY_CHANGED, { layerId: action.IdMapLayer, visible: true }, this, this.classId);
            layer.setVisible(true);
            //CG: notificarea vine de la legenda insasi, deci handler-ul ei o ignora - comutatorul se aliniaza aici
            this._syncLayerVisibility(action.IdMapLayer, true);
        }

        // Alegerea tipului pe layerele 'ALL' o face EditControl, ca sa fie la fel din legenda si din formular.
        this.mapControl.generalActionHandler.generalActionControls.editControl.startInsert(action.IdMapLayer, null, null, action, evt);
    }

    _initDynamicGeneralAction(action) {
        switch (action.SubType) {
            case actionTypes.SUBTYPE_LIST: this._handleOpenListControl(action);
                break;
            case actionTypes.SUBTYPE_JS: this._handleJsAction(action);
                break;
            default: break;
        }
    }

    _handleJsAction(action) {
        let actionHandler = window['xp_map_layer_action_' + action.Id + '_onClick'];
        if (actionHandler) {
            actionHandler();
        }
    }

    _handleOpenListControl(config) {
        let _url = this.rootURL + 'EntityList/EntityListRuntime?context=modal&id=' + config.IdListTarget + '&idApp=' + xapp.currentApp + '&idRef=ACT_' + config.Id;

        var layer = this.mapControl.layerSettingsHandler.getLayerSettings(config.IdMapLayer);

        if (layer != null && layer.IdExtConn != null) {
            _url += "&idExtConn=" + layer.IdExtConn;
        }

        let width = null;
        let height = null;

        if (config.UiContent != null && config.UiContent.trim() != '') {
            let uiContent = JSON.parse(config.UiContent);

            if (uiContent.modalWidth != null && uiContent.modalWidth.trim() != '') {
                width = uiContent.modalWidth;
            }

            if (uiContent.modalHeight != null && uiContent.modalHeight.trim() != '') {
                height = uiContent.modalHeight;
            }
        }

        if (this._checkMobile()) {
            width = '100%';
            height = '100%';
        }

        showModalWindow(_url, config.Text, config.Icon, width, height);
    }

    _checkMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    _addLayerFitHandler(layer) {
        let element = document.getElementById(this.legendLayerFitPrefix + layer.Id);

        if (element != null) {
            element.addEventListener('click', (evt) => {
                $event.notify(eventTypes.LAYER_FIT, { layerId: layer.Id }, this, this.classId);
            });
        }
    }

    _addLayerFilterHandler(layer) {
        let element = document.getElementById(this.legendLayerFilterPrefix + layer.Id);

        if (element != null) {
            element.addEventListener('click', (evt) => {
                if (layer.Filtered) {
                    this._showFilter(layer);
                } else {
                    this._showFilter(layer);
                }
            });
        }
    }

    _showFilter(layer) {
        $('#' + this.legendFilterModalHelper)[0].innerHTML = '<div id="filter-modal-inner" style="padding: 0; padding-bottom: 0.25rem;"></div>';

        let modalOptions = {
            draggable: false,
            resizable: true,
            width: "25%",
            height: "auto",
            maxHeight: 700,
            title: this.resourcesHandler.get('Filter'),
            modal: true,
            close: () => { this.closeModal(); }
        };

        $('#filter-modal-inner').kendoWindow(modalOptions);

        if ($('body')[0].classList.contains('mod-skin-dark')) {
            $('.k-window').addClass('mod-skin-dark');
        }

        $('#filter-modal-inner').siblings('.k-window-titlebar').css('padding', '0.5rem');

        // FormControl construieste URL-urile dintr-un global 'rootUrl' (minuscul). In pagina hartii (MapRun.cshtml)
        // exista doar 'rootURL' (majuscul), deci global-ul 'rootUrl' e undefined si toate request-urile formularului
        // de filtru ar deveni 'undefined...'. Il alimentam din this.rootURL inainte de a instantia FormControl.
        if (window.rootUrl == null) {
            window.rootUrl = this.rootURL;
        }

        this.currentFilterControl = new FormControl({
            localization: this.resourcesHandler.resources,
            actionLocalization: this.resourcesHandler.resources,
            isPreview: false,
            container: 'filter-modal-inner',
            pageGuid: this._generateUUID(),
            objectId: '0',
            formId: layer.Id,
            idExtConn: layer.IdExtConn,
            layoutId: layer.Id < 0 ? layer.Id : layer.IdFilter,
            isFilter: true,
            listControl: this,
            generalResources: this.resourcesHandler.resources,
            customFormResources: this.resourcesHandler.resources
        });

        let url = this.rootURL + paths.MAP_LAYER_FILTER + layer.IdFilter;

        if (layer.Id < 0) {
            url = this.rootURL + paths.MAP_EXTERNAL_LAYER_FILTER.replaceAll('{0}', (-layer.Id)).replaceAll('{1}', this.mapId);
        }

        $.ajax({
            type: "GET",
            url: url,
            contentType: "application/json; charset=utf-8",
            success: (result) => {
                let mapFilters = localStorage.getItem('mapFilters');

                if (mapFilters == null) {
                    mapFilters = null;
                } else {
                    mapFilters = JSON.parse(mapFilters);
                }

                if (mapFilters != null && mapFilters[layer.Id] != null) {
                    this.currentFilterControl.serverData = mapFilters[layer.Id];
                    this.currentFilterControl.dataItem = mapFilters[layer.Id];
                }
                this.currentFilterControl.loadForm(result, []);
            }
        });

        this.centerModal();
    }

    filterLoaded() {
        this.centerModal();
    }

    notifyFilters(filters) {
        let mapFilters = localStorage.getItem('mapFilters');

        if (mapFilters == null) {
            mapFilters = {};
        } else {
            mapFilters = JSON.parse(mapFilters);
        }

        mapFilters[this.currentFilterControl.formId] = filters.values;

        localStorage.setItem('mapFilters', JSON.stringify(mapFilters));

        let hasFilters = false;

        let keys = Object.keys(filters.values);

        keys.forEach(key => {
            if (filters.values[key] != null) {
                if (typeof filters.values[key] == 'string') {
                    if (filters.values[key].trim() != '') {
                        hasFilters = true;
                    }
                } else {
                    hasFilters = true;
                }
            }
        });

        mapFilters[this.currentFilterControl.formId] = hasFilters ? filters.values : null;

        let layerConfig = this.mapControl.layerSettingsHandler.getLayerSettings(this.currentFilterControl.formId);

        if (hasFilters) {
            layerConfig.Filtered = true;
            this.appliedFilter[this.currentFilterControl.formId] = true;
            $('#' + this.legendLayerFilterPrefix + this.currentFilterControl.formId).removeClass('btn-secondary');
            $('#' + this.legendLayerFilterPrefix + this.currentFilterControl.formId).addClass('btn-primary');
        } else {
            layerConfig.Filtered = false;
            this.appliedFilter[this.currentFilterControl.formId] = false;
            $('#' + this.legendLayerFilterPrefix + this.currentFilterControl.formId).addClass('btn-secondary');
            $('#' + this.legendLayerFilterPrefix + this.currentFilterControl.formId).removeClass('btn-primary');
        }

        let updatedFilters = [];

        if (hasFilters) {
            keys.forEach(key => {
                let currentItem = this.currentFilterControl.getFieldMetadataByInternalId(key.replaceAll('fld_', ''));
                let currentItemValue = filters.values[key];

                if (Array.isArray(currentItemValue)) {
                    currentItemValue = currentItemValue.join(',');
                    currentItem.FilterOp = 'IN';
                }

                if (currentItemValue != null && currentItem.EntityField != null) {
                    switch (currentItem.EntityField.DataType) {
                        case 'STRING': {
                            switch (currentItem.FilterOp) {
                                case 'CONTAINS': updatedFilters.push("strToLowerCase(" + currentItem.EntityField.FieldName + ")" + " like '%" + currentItemValue.toLowerCase() + "%'");
                                    break;
                                case '=': updatedFilters.push(currentItem.EntityField.FieldName + "='" + currentItemValue + "'");
                                    break;
                                case 'LIKE': updatedFilters.push("strToLowerCase(" + currentItem.EntityField.FieldName + ")" + " like '%" + currentItemValue.toLowerCase() + "%'");
                                    break;
                                case 'STARTSWITH': updatedFilters.push("strToLowerCase(" + currentItem.EntityField.FieldName + ")" + " like '" + currentItemValue.toLowerCase() + "%'");
                                    break;
                                case 'ENDSWITH': updatedFilters.push("strToLowerCase(" + currentItem.EntityField.FieldName + ")" + " like '%" + currentItemValue.toLowerCase() + "'");
                                    break;
                                case 'IN': updatedFilters.push("strToLowerCase(" + currentItem.EntityField.FieldName + ")" + " in (" + currentItemValue.toLowerCase() + ")");
                                    break;
                                default: updatedFilters.push("strToLowerCase(" + currentItem.EntityField.FieldName + ")" + " like '" + currentItemValue.toLowerCase() + "%'");
                                    break;
                            }
                        }
                            break;
                        case 'NUMERIC':
                        case 'BOOLINT':
                        case 'INTEGER': {
                            if (currentItemValue != null && currentItemValue.toString().trim().length > 0) {
                                switch (currentItem.FilterOp) {
                                    case '=': updatedFilters.push(currentItem.EntityField.FieldName + "=" + currentItemValue);
                                        break;
                                    case '<': updatedFilters.push(currentItem.EntityField.FieldName + "<" + currentItemValue);
                                        break;
                                    case '<=': updatedFilters.push(currentItem.EntityField.FieldName + "<=" + currentItemValue);
                                        break;
                                    case '>': updatedFilters.push(currentItem.EntityField.FieldName + ">" + currentItemValue);
                                        break;
                                    case '>=': updatedFilters.push(currentItem.EntityField.FieldName + ">=" + currentItemValue);
                                        break;
                                    case 'IN': updatedFilters.push(currentItem.EntityField.FieldName + " in (" + currentItemValue + ")");
                                        break;
                                    default: updatedFilters.push(currentItem.EntityField.FieldName + "=" + currentItemValue);
                                        break;
                                }
                            }
                        }
                            break;
                    }
                }
            });
        }

        if (layerConfig.Type.toLowerCase() == "geoservice") {
            if (layerConfig.Geoservice.ServiceType.toLowerCase() == 'wms') {
                let cqlFilter = this.getCqlFilters(updatedFilters);
                this.mapControl.getLayer(layerConfig.Id).getSource().getParams().CQL_FILTER = cqlFilter;
            } else if (layerConfig.Geoservice.ServiceType.toLowerCase() == 'geojson') {
                // Filtru pe geoservice GEOJSON: nu construim CQL, ci inlocuim token-urile {NumeCamp} din URL.
                // Conventie: token == EntityField.FieldName. Valorile sunt formatate (dupa Format-ul campului) si encodate aici,
                // apoi inlocuite in query string la momentul fetch-ului in handleGeoserviceGeojsonWfsUrl.
                let tokens = hasFilters ? this._buildGeojsonFilterTokens(filters.values) : null;

                layerConfig.GeojsonFilterTokens = tokens;
                mapFilters[this.currentFilterControl.formId + '_geojson'] = tokens;
            }
        } else if (layerConfig.Entity != null) {
            layerConfig.Filters = filters.values;
            if (layerConfig.Interpretation == 'NATIVE_XP') {
                layerConfig.Filters = hasFilters ? filters.values : null;
            } else if (layerConfig.Interpretation == 'WFS') {
                let wfsFilters = [];

                updatedFilters.forEach((updatedFilter) => {
                    wfsFilters.push({
                        field: updatedFilter,
                        op: '',
                        vals: ['']
                    })
                });

                layerConfig.WfsFilters = wfsFilters;
                layerConfig.Filters = hasFilters ? filters.values : null;

                mapFilters[this.currentFilterControl.formId + '_wfs'] = hasFilters ? wfsFilters : null;
            }
        }

        localStorage.setItem('mapFilters', JSON.stringify(mapFilters));
        //if (layerConfig.type.toLowerCase() == "geoservice") {
        //    if (layerConfig.serviceType.toLowerCase() == 'wms') {
        //        let cqlFilter = this.getCqlFilters(updatedFilters);
        //        layer.getSource().getParams().CQL_FILTER = cqlFilter;
        //    } else if (layerConfig.serviceType.toLowerCase() == 'wfs') {

        //    }
        //} else {
        //    if (layerConfig.interpretation.toLowerCase() == 'wms') {
        //        let cqlFilter = this.getCqlFilters(updatedFilters);
        //        layer.getSource().getParams().CQL_FILTER = cqlFilter;
        //    } else if (layerConfig.interpretation.toLowerCase() == 'wfs' || layerConfig.interpretation.toLowerCase() == 'heat_layer' || layerConfig.interpretation.toLowerCase() == 'cluster') {
        //        let wfsFilters = [];

        //        updatedFilters.forEach((updatedFilter) => {
        //            wfsFilters.push({
        //                field: updatedFilter,
        //                op: '',
        //                vals: ['']
        //            })
        //        });

        //        layer.set('filters', wfsFilters);
        //    } else if (layerConfig.interpretation.toLowerCase() == 'native_xp') {
        //        layer.set('filters', filters.values);
        //    }
        //}

        // Geoservice GEOJSON foloseste allStrategy: sursa se incarca o singura data si nu re-apeleaza URL-ul.
        // Fortam refresh-ul (clear + refresh) ca sa se refaca fetch-ul cu token-urile de filtru substituite.
        let forceRefresh = layerConfig.Type.toLowerCase() == "geoservice"
            && layerConfig.Geoservice != null
            && layerConfig.Geoservice.ServiceType.toLowerCase() == 'geojson';

        this.mapControl.refreshLayer(layerConfig.Id, forceRefresh);
        this.closeModal();
    }

    // Construieste maparea token -> valoare pentru filtrarea unui geoservice GEOJSON.
    // Cheia este EntityField.FieldName (conventia token == NumeCamp), iar valoarea este formatata dupa
    // Format-ul/DataType-ul campului si encodata cu encodeURIComponent (deci fara risc de injectie - nu construim predicate).
    // Pentru operatorul IN (selectie multipla) valorile sunt unite cu virgula, encodate individual.
    _buildGeojsonFilterTokens(filterValues) {
        let tokens = {};

        Object.keys(filterValues).forEach((key) => {
            let value = filterValues[key];

            if (value == null || (typeof value == 'string' && value.trim() == '')) {
                return;
            }

            let currentItem = this.currentFilterControl.getFieldMetadataByInternalId(key.replaceAll('fld_', ''));

            if (currentItem == null || currentItem.EntityField == null) {
                return;
            }

            let fieldName = currentItem.EntityField.FieldName;
            let dataType = currentItem.EntityField.DataType;
            let format = currentItem.Format;

            let encoded;

            if (Array.isArray(value)) {
                encoded = value
                    .map((v) => encodeURIComponent(this._formatGeojsonFilterValue(v, dataType, format)))
                    .join(',');
            } else {
                encoded = encodeURIComponent(this._formatGeojsonFilterValue(value, dataType, format));
            }

            tokens[fieldName] = encoded;
        });

        return tokens;
    }

    // Formateaza o valoare de filtru dupa Format-ul campului (acelasi Format folosit de controlul din formular).
    // Serviciul extern este o cutie neagra, deci formatul (in special pentru date) trebuie sa corespunda cu ce asteapta el.
    _formatGeojsonFilterValue(value, dataType, format) {
        if (value == null) {
            return '';
        }

        if ((dataType == 'DATE' || dataType == 'TIMESTAMP') && format != null && format.trim() != '') {
            // Valoarea vine deja serializata in formatul intern XPortal (Y-M-D / Y-M-D-H-m-s, fara padding, luna 1-based).
            // O deserializam cu acelasi mecanism folosit de FormControl, apoi o formatam dupa Format-ul campului.
            let date;

            if (value instanceof Date) {
                date = value;
            } else if (dataType == 'TIMESTAMP') {
                date = this.currentFilterControl._deserializeDateTime(value);
            } else {
                date = this.currentFilterControl._deserializeDate(value);
            }

            if (date != null && !isNaN(date.getTime())) {
                // Format-ul campului poate fi scris in stil moment (YYYY-MM-DD); kendo.toString foloseste token-uri .NET
                // (yyyy-MM-dd), deci il translatam inainte de formatare.
                return kendo.toString(date, this._toKendoDateFormat(format));
            }
        }

        if ((dataType == 'NUMERIC' || dataType == 'INTEGER') && format != null && format.trim() != '') {
            let num = typeof value == 'number' ? value : parseFloat(value);

            if (!isNaN(num)) {
                return kendo.toString(num, format);
            }
        }

        return value.toString();
    }

    // Translateaza token-urile de format in stil moment catre token-urile .NET/Kendo, ca sa putem folosi kendo.toString.
    // Doar anul (Y->y) si ziua lunii (D->d) difera intre cele doua dialecte; luna (M/MM), ora (HH), minutul (mm)
    // si secunda (ss) sunt identice, deci nu le atingem. Un format deja in stil Kendo (yyyy-MM-dd) ramane neschimbat.
    _toKendoDateFormat(format) {
        if (format == null) {
            return format;
        }

        return format
            .replace(/Y/g, 'y')
            .replace(/D/g, 'd');
    }

    getCqlFilters(layerFilters) {
        if (layerFilters != null && layerFilters.length > 0) {
            if (layerFilters.length == 1) {
                var _filters = "";
                if (_filters != "") {
                    _filters += " AND ";
                }
                _filters += layerFilters[0];

                return _filters;
            }

            var _filters = "";
            for (var i = 0; i < layerFilters.length; i++) {
                if (_filters != "") {
                    _filters += " AND ";
                }
                _filters += "(" + layerFilters[i] + ")";
            }
            return _filters;
        }

        return null;
    }
    _generateUUID() {
        var d = new Date().getTime();
        var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16;
            if (d > 0) {
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        }).replaceAll('-', '');
    }

    closeModal() {
        $('#filter-modal-inner').data("kendoWindow").destroy();
    }

    centerModal() {
        $('#filter-modal-inner').data("kendoWindow").center();
    }

    _addLayerVisibilityHandler(layer) {
        $("#" + this.legendSwitchPrefix + layer.Id).kendoSwitch({
            messages: {
                checked: '',
                unchecked: ''
            },
            width: 30,
            checked: layer.VisibleByDefault,
            change: (e) => {
                let checked = e.checked;
                this._handleLayerVisibility(layer, checked, false);
            }
        });
    }

    _addClassificationLayerVisibilityHandler(layer) {
        layer.classifications.forEach(classification => {
            $("#" + this.legendSwitchPrefix + layer.Id + '-' + classification.idx).kendoSwitch({
                messages: {
                    checked: '',
                    unchecked: ''
                },
                width: 30,
                checked: layer.VisibleByDefault,
                change: (e) => {
                    let checked = e.checked;
                    this._handleClassificationLayerVisibility(layer, classification, checked, false);
                }
            });
        });
    }

    _handleClassificationLayerVisibility(layer, classification, checked, trigger) {
        if (!$("#" + this.legendSwitchPrefix + layer.Id + '-' + classification.idx).data('kendoSwitch')) {
            return;
        }

        if (trigger) {
            $("#" + this.legendSwitchPrefix + layer.Id + '-' + classification.idx).data('kendoSwitch').check(checked);
        }

        $event.notify(eventTypes.LAYER_CLASSIFICATION_VISIBILITY_CHANGED, { layerId: layer.Id, classificationIdx: classification.idx, visible: checked }, this, this.classId);

        if (!trigger) {
            let allChecked = true;
            let allUnchecked = true;

            layer.classifications.forEach(classif => {
                if ($("#" + this.legendSwitchPrefix + layer.Id + '-' + classif.idx).data('kendoSwitch').check()) {
                    allUnchecked = false;
                }
            });

            if (allUnchecked) {
                $("#" + this.legendSwitchPrefix + layer.Id).data('kendoSwitch').check(false);
                $event.notify(eventTypes.LAYER_VISIBILITY_CHANGED, { layerId: layer.Id, visible: false }, this, this.classId);
                this._handleParentsVisibility(layer, false);
            } else {
                $("#" + this.legendSwitchPrefix + layer.Id).data('kendoSwitch').check(true);
                $event.notify(eventTypes.LAYER_VISIBILITY_CHANGED, { layerId: layer.Id, visible: true }, this, this.classId);
                this._handleParentsVisibility(layer, true);
            }
        }
    }

    _handleLayerVisibility(layer, checked, trigger) {
        if (trigger && $("#" + this.legendSwitchPrefix + layer.Id).data('kendoSwitch') != null) {
            $("#" + this.legendSwitchPrefix + layer.Id).data('kendoSwitch').check(checked);
        }

        $event.notify(eventTypes.LAYER_VISIBILITY_CHANGED, { layerId: layer.Id, visible: checked }, this, this.classId);

        if (layer.Items != null && layer.Items.length > 0) {
            layer.Items.forEach(item => {
                this._handleLayerVisibility(item, checked, true);
            });
        }

        if (layer.hasClassification) {
            layer.classifications.forEach(classification => {
                this._handleClassificationLayerVisibility(layer, classification, checked, true);
            });
        }

        if (!trigger) {
            this._handleParentsVisibility(layer, checked);
        }
    }

    _handleParentsVisibility(layer, checked) {
        let parent = this._searchLayerParent(layer, this.layerSettingsHandler.layers);

        if (parent != null) {
            let siblings = parent.Items;

            let allChecked = true;

            siblings.forEach(sibling => {
                if ($("#" + this.legendSwitchPrefix + sibling.Id).data('kendoSwitch').check() != checked) {
                    allChecked = false;
                    return;
                }
            });

            if (allChecked) {
                $("#" + this.legendSwitchPrefix + parent.Id).data('kendoSwitch').check(checked);
                $event.notify(eventTypes.LAYER_VISIBILITY_CHANGED, { layerId: parent.Id, visible: checked }, this, this.classId);

                this._handleParentsVisibility(parent, checked);
            }
        }
    }

    _searchLayerParent(layer, layers, parent) {
        let found;

        for (let i = 0; i < layers.length; i++) {
            if (layers[i].Id == layer.Id) {
                found = parent;
            } else if (layers[i].Items != null && layers[i].Items.length > 0) {
                found = this._searchLayerParent(layer, layers[i].Items, layers[i]);
            }
        }

        return found;
    }

    _addLayerOpacityHandler(layer) {
        let range = document.getElementById(this.legendLayerOpacityPrefix + layer.Id);

        if (range != null) {
            range.addEventListener('input', (evt) => {
                let value = evt.currentTarget.value / 100;
                $event.notify(eventTypes.LAYER_OPACITY_CHANGED, { layerId: layer.Id, opacity: value }, this, this.classId);
            });
        }
    }

    _addNewChartHandler(layer) {
        let button = document.getElementById(this.addNewChartButtonPrefix + layer.Id);

        if (button != null) {
            button.addEventListener('click', () => {
                this.chartConfigurator.addNewChart(layer);
            });
        }

        if (layer.Charts != null) {
            let charts = Object.keys(layer.Charts);

            charts.forEach(chartId => {
                this._addChartEvents(layer, chartId);
            });
        }
    }

    _addChartEvents(layer, chartId) {
        let chart = layer.Charts[chartId];

        $('#' + this.editLegendChart + chartId).on('click', () => {
            $event.notify(eventTypes.CHART_UPDATE, { layerId: layer.Id, chartId: chartId }, this, this.classId);
        });

        $('#' + this.deleteLegendChart + chartId).on('click', () => {
            $('#' + this.legendChart + chartId).remove();
            $event.notify(eventTypes.CHART_REMOVED, { layerId: layer.Id, chartId: chartId }, this, this.classId);
        });
    }

    _allowDropLegendNode(evt) {
        this.currentDropItem = null;
        evt.preventDefault();
        if (evt.target.classList.contains('non-draggable') || evt.target.parentElement.classList.contains('non-draggable')
            || evt.target.classList.contains('drag-handle') || evt.target.classList.contains('clone') || evt.target.closest('.drag-handle') != null) {
            return;
        }

        [...document.getElementsByClassName('drag-handle')].forEach(dragHandle => {
            dragHandle.classList.remove('show');
        });

        let target = evt.target;

        if (target.parentElement != null && target.parentElement.classList.contains('legend-layer')) {
            target = target.parentElement;
        } else if (target.parentElement != null && target.parentElement.parentElement != null && target.parentElement.parentElement.classList.contains('legend-layer')) {
            target = target.parentElement.parentElement;
        }

        if (target.classList.contains('legend-layer') && !target.classList.contains('clone')) {
            let pointerY = evt.clientY;
            let targetYStart = target.getBoundingClientRect().y;
            let targetHeight = target.getBoundingClientRect().height;
            let targetYEnd = targetYStart + targetHeight;

            let isBefore = true;

            if (targetYEnd - pointerY < targetHeight / 2) {
                isBefore = false;
            }

            let layerId = target.parentElement.getAttribute('data-id');

            if (isBefore) {
                let layersAtLevel = [];
                if (target.parentElement.parentElement.classList.contains('legend-group-layer')) {
                    layersAtLevel = target.parentElement.parentElement.parentElement.children;
                } else {
                    layersAtLevel = target.parentElement.parentElement.children;
                }

                for (let i = 0; i < layersAtLevel.length; i++) {
                    if (layersAtLevel[i].getAttribute('data-id') == layerId) {
                        let previousLayerId = layersAtLevel[i - 1].getAttribute('data-id');

                        if (layersAtLevel[i - 1].classList.contains('drag-handle')) {
                            if (layersAtLevel[i - 1].closest('[data-id="' + document.querySelector(this.currentDragItem).getAttribute('data-id') + '"]') == null) {
                                this.currentDropItem = layersAtLevel[i - 1];
                                this.currentDropItem.classList.add('show');
                            }
                        } else if (layersAtLevel[i - 1].classList.contains('legend-group-layer')) {
                            this.currentDropItem = document.querySelector('.drag-handle-group-after[data-id="' + previousLayerId + '"]');
                            if (this.currentDropItem) {
                                this.currentDropItem.classList.add('show');
                            }
                        } else {
                            if (previousLayerId == null) {
                                this.currentDropItem = document.querySelector('.drag-handle.anchor');
                                this.currentDropItem.classList.add('show');
                            } else {
                                if (document.querySelector('.drag-handle[data-id="' + previousLayerId + '"]') != null
                                    && document.querySelector('.drag-handle[data-id="' + previousLayerId + '"]')
                                        .closest('[data-id="' + document.querySelector(this.currentDragItem)
                                            .getAttribute('data-id') + '"]') == null) {
                                    this.currentDropItem = document.querySelector('.drag-handle[data-id="' + previousLayerId + '"]');
                                    this.currentDropItem.classList.add('show');
                                }
                            }
                        }
                    }
                }
            } else {
                if (document.querySelector('.drag-handle[data-id="' + layerId + '"]') != null
                    && document.querySelector('.drag-handle[data-id="' + layerId + '"]')
                        .closest('[data-id="' + document.querySelector(this.currentDragItem)
                            .getAttribute('data-id') + '"]') == null) {
                    this.currentDropItem = document.querySelector('.drag-handle[data-id="' + layerId + '"]');
                    this.currentDropItem.classList.add('show');
                }
            }
        }
    }

    _dropLegendNode(evt) {
        evt.preventDefault();
        [...document.getElementsByClassName('drag-handle')].forEach(dragHandle => {
            dragHandle.classList.remove('show');
        });

        if (this.currentDropItem != null) {
            if (this.currentDropItem.classList.contains('anchor') || this.currentDropItem.classList.contains('drag-handle-group-before')) {
                this.currentDropItem.after(document.querySelector(this.currentDragItem));
            } else if (this.currentDropItem.classList.contains('drag-handle-group-after')) {
                this.currentDropItem.parentElement.after(document.querySelector(this.currentDragItem));
            } else {
                this.currentDropItem.parentElement.after(document.querySelector(this.currentDragItem));
            }

            let hierarchy = this._getLegendHierarchy();
            $event.notify(eventTypes.LAYER_ORDER_CHANGED, { layers: hierarchy }, this, this.classId);
        }
    }

    _getLegendHierarchy() {
        let legendNodes = document.getElementById(this.legendContentElementId).children;
        let result = [];
        this._computeLegendNodeHierarchy(legendNodes, result);
        return result;
    }

    _computeLegendNodeHierarchy(nodes, result) {
        for (let i = 0; i < nodes.length; i++) {
            let node = nodes[i];

            if (node.classList.contains('legend-group-layer') && !node.classList.contains('legend-layer-classifications')) {
                let childrenElements = node.children;
                let group = { Id: node.getAttribute('data-id'), Items: [] };
                let children = childrenElements[this.legendGroupWrapperPrefix + group.Id].children;
                this._computeLegendNodeHierarchy(children, group.Items);
                result.push(group);
            } else if (node.classList.contains('legend-layer-wrapper') || node.classList.contains('legend-layer-classifications')) {
                result.push({ Id: node.getAttribute('data-id') });
            }
        }
    }

    _dragLegendNode(evt) {
        let target = evt.target.parentElement.parentElement;

        if (target.parentElement.classList.contains('legend-group-layer')) {
            target = target.parentElement;
        }

        this.currentDragItem = '.' + target.classList[0] + '[data-id="' + target.getAttribute('data-id') + '"]';
    }

    _addLayers() {
        let template = this._getLayersTemplate(this.layerSettingsHandler.layers);
        document.getElementById(this.legendContentWrapperElementId).appendChild(template);
        this.chartConfigurator = new ChartConfigurator(this.rootURL, this.resourcesHandler, document.getElementById(this.legendExtraModalHelper), this.layerSettingsHandler, this.classId);
        this.chartConfigurator.init();
    }

    _getTitle() {
        if (this.action.Title != null && this.action.Title != '') {
            return this.action.Title;
        }

        return this.resourcesHandler.get('SubType_' + this.action.SubType);
    }

    /* TEMPLATES */

    _getLayersTemplate(layers) {
        let div = document.createElement('div');

        let template = `<div class="map-legend k-treeview" id="` + this.legendContentElementId + `"><div class="drag-handle anchor"><span>&#10522;</span></div>` + this._getLegendLayersTemplate(layers) + `</div>`;

        div.innerHTML = template;

        return div.firstChild;
    }

    _getLegendLayersTemplate(layers) {
        let template = ``;

        for (let i = 0; i < layers.length; i++) {
            let layer = layers[i];
            switch (layer.Type) {
                case layerTypes.GROUP: template += this._getGroupLegendLayerTemplate(layer);
                    break;
                default: template += this._getLegendLayerWrapperTemplate(layer);
                    break;
            }
        }

        return template;
    }

    _getGroupLegendLayerTemplate(layer) {
        if (layer.Id == 0)
            layer.Id = layer.Name;

        let template = `<div class="legend-group-layer" data-id="` + layer.Id + `" hidden-by-filter="0">
                            <span class="k-icon k-i-expand ni ni-chevron-down" id="` + (this.legendCollapsePrefix + layer.Id) + `"></span>
                            ` + this._getLegendLayerWrapperTemplate(layer) + `
                            <div id="` + (this.legendGroupWrapperPrefix + layer.Id) + `" class="legend-group-items hide"><div class="drag-handle drag-handle-group-before" data-id="` + layer.Id + `"><span>&#10522;</span></div>` + (layer.Items != null ? this._getLegendLayersTemplate(layer.Items) : ``) + `</div>
                            <div class="drag-handle drag-handle-group-after" data-id="` + layer.Id + `"><span>&#10522;</span></div>
                        </div>`;
        return template;
    }

    _getLegendLayerWrapperTemplate(layer) {
        let classification = this._getClassificationsForLayer(layer);

        if (classification != null && classification.length > 0) {
            layer.hasClassification = true;
            layer.classifications = classification;
            return this._getLegendLayerWithClassificationsTemplate(layer, classification);
        } else {
            layer.hasClassification = false;
            layer.classifications = null;
            let template = `<div class="legend-layer-wrapper" data-id="` + layer.Id + `" hidden-by-filter="0">`;
            template += this._getLegendLayerTemplate(layer, true);
            template += `</div>`;

            return template;
        }
    }

    _getLegendLayerWithClassificationsTemplate(layer, classifications) {
        let template = `<div class="legend-layer-classifications legend-group-layer" data-id="` + layer.Id + `" hidden-by-filter="0">`
            + this._getLegendLayerWithClassificationsContentTemplate(layer, classifications) +
            `<div class="drag-handle" data-id="` + layer.Id + `"><span>&#10522;</span></div>
            </div>`;

        return template;
    }

    _getLegendLayerWithClassificationsContentTemplate(layer, classifications) {
        let template = `<span class="k-icon k-i-expand ni ni-chevron-down" id="` + (this.legendCollapsePrefix + layer.Id) + `"></span>
                        <div class="legend-layer-wrapper" data-id="` + layer.Id + `" hidden-by-filter="0">
                        ` + this._getLegendLayerTemplate(layer, false) + `
                        </div>
                        <div id="` + (this.legendGroupWrapperPrefix + layer.Id) + `" class="legend-group-items hide">`
            + this._getClassificationsTemplate(layer, classifications) +
            `</div>`;

        return template;
    }

    _getClassificationsTemplate(layer, classifications) {
        let template = ``;
        classifications.forEach(classification => {
            template += `<div class="legend-layer-wrapper non-draggable" data-id="` + layer.Id + '-' + classification.idx + `" hidden-by-filter="0">`;
            template += this._getLegendClassificationLayerTemplate(layer, classification);
            template += `</div>`;
        });

        return template;
    }

    _getLegendClassificationLayerTemplate(layer, classification) {
        let template = `<div class="legend-layer non-draggable">
                            ` + ((layer.Type != layerTypes.GROUP && ((layer.Type == layerTypes.ENTITY && (layer.Interpretation == layerTypes.WFS || layer.Interpretation == layerTypes.VECTOR_TILE || layer.Interpretation == layerTypes.XP_NATIVE)) || (layer.Type == layerTypes.GEOSERVICE && layer.Interpretation == layerTypes.WFS)
                || layer.Type == layerTypes.TEMPORARY_VECTOR)) ? `<div id="` + (this.legendSwitchPrefix + layer.Id + '-' + classification.idx) + `" class="legend-layer-switch"></div>` : ``) + `
                            <div class="legend-layer-preview non-draggable">` + this._getLegendClassificationLayerPreview(layer, classification) + `</div>
                            <div id="` + (this.legendDetailsPrefix + layer.Id + '-' + classification.idx) + `" class="legend-layer-details non-draggable" draggable="false">
                                <div class="legend-layer-title non-draggable" id="` + (this.legendTitlePrefix + layer.Id + '-' + classification.idx) + `">` + this._escapeHtml(classification.name) + `</div>
                            </div>
                        </div>`;
        return template;
    }

    // constructie unificata (legenda ecran + print) prin modulul comun classificationRows:
    // prefera clasificarea calculata la runtime (layer.thematicClassification) fata de descriptorul salvat
    _getClassificationsForLayer(layer) {
        return classificationRows.classificationsFromLayer(layer, this.styleHandler.styles, this.resourcesHandler.get('LegendIntervalTemplate'));
    }

    // escapare HTML pentru text nesigur (valorile categoriale provin din date) inserate prin innerHTML
    _escapeHtml(value) {
        if (value == null) {
            return '';
        }

        return String(value)
            .replaceAll('&', '&amp;')
            .replaceAll('<', '&lt;')
            .replaceAll('>', '&gt;')
            .replaceAll('"', '&quot;')
            .replaceAll("'", '&#39;');
    }

    _getLegendLayerTemplate(layer, addDragHandle) {
        let template = `<div class="legend-layer">
                                <div id="` + (this.legendSwitchPrefix + layer.Id) + `" class="legend-layer-switch"></div>
                                <div class="legend-layer-preview">` + this._getLegendLayerPreview(layer) + `</div>
                                <div id="` + (this.legendDetailsPrefix + layer.Id) + `" class="legend-layer-details" draggable="true">
                                    <div class="legend-layer-title" id="` + (this.legendTitlePrefix + layer.Id) + `">` + layer.Title + `</div>
                                </div>
                                <div class="legend-layer-actions">` + this._getLegendLayerActionsTemplate(layer) + `</div>
                            </div>`;

        if (layer.Type != layerTypes.GROUP) {
            if (layer.Opacity == null) {
                layer.Opacity = 1;
            }

            template += `<div class="legend-layer-options hide" id="` + (this.legendLayerOptionsWrapperPrefix + layer.Id) + `"></div>`;

            if (addDragHandle) {
                template += `<div class="drag-handle" data-id="` + layer.Id + `"><span>&#10522;</span></div>`;
            }
        }

        return template;
    }

    _getLegendLayerActionsTemplate(layer) {
        let template = ``;

        if (layer.Type != layerTypes.GROUP) {
            template += `<span class="k-icon k-i-expand ni ni-chevron-down legend-layer-option normal-layer-option" id="` + (this.legendLayerOptionsSwitchPrefix + layer.Id) + `"></span>`;
        }

        template += `<div class="d-flex" id="` + (this.legendLayerAdditionalOptionsPrefix + layer.Id) + `"></div>`;

        //if (layer.Type != layerTypes.GROUP && (layer.Type == layerTypes.XP_NATIVE || layer.Type == layerTypes.ENTITY || (layer.Type == layerTypes.GEOSERVICE && layer.Interpretation == layerTypes.WFS))) {
        //    template += `<span title="` + this.resourcesHandler.get('EditTooltip') + `" class="fal fa-text-width legend-layer-option normal-layer-option" id="` + (this.legendLayerTooltipPrefix + layer.Id) + `"></span>`;
        //}

        if (layer.Type != layerTypes.GROUP && (layer.Type == layerTypes.XP_NATIVE || layer.Type == layerTypes.ENTITY || (layer.Type == layerTypes.GEOSERVICE && layer.Interpretation == layerTypes.WFS) || layer.Type == layerTypes.TEMPORARY_VECTOR)) {
            template += `<span title="` + this.resourcesHandler.get('FitLayer') + `" class="fal fa-expand legend-layer-option normal-layer-option" id="` + (this.legendLayerFitPrefix + layer.Id) + `"></span>`;

            if (layer.IdHighlightStyle != null || layer.IdSelectStyle != null) {
                template += `<span title="` + this.resourcesHandler.get('Selectable') + `" class="fal fa-mouse-pointer normal-layer-option legend-toggle-option btn ` + (layer.Selectable ? `btn-primary` : `btn-secondary`) + `" id="` + (this.legendLayerSelectablePrefix + layer.Id) + `"></span>`;
            }
        }

        if (layer.Type != layerTypes.GROUP && layer.Id < 0) {
            template += `<span title="` + this.resourcesHandler.get('FilterLayer') + `" class="mr-1 fal fa-filter normal-layer-option legend-toggle-option btn ` + (layer.Filtered ? `btn-primary` : `btn-secondary`) + `" id="` + (this.legendLayerFilterPrefix + layer.Id) + `"></span>`;
        }

        if (layer.IdFilter) {
            template += `<span title="` + this.resourcesHandler.get('FilterLayer') + `" class="mr-1 fal fa-filter normal-layer-option legend-toggle-option btn ` + (layer.Filtered ? `btn-primary` : `btn-secondary`) + `" id="` + (this.legendLayerFilterPrefix + layer.Id) + `"></span>`;
        }

        let generalActions = this._getLayerGeneralAction(layer);

        if (generalActions.length > 0) {
            generalActions.forEach(action => {
                if (action.SubType == actionTypes.SUBTYPE_SEPARATOR) {
                    template += `<span class="map-layer-action-separator"></span>`;
                } else if (action.SubType == actionTypes.SUBTYPE_GROUP) {
                    let title = action.Title != null && action.Title != '' ? action.Title : this._getLayerActionLabel(action);
                    let content = action.Icon != null && action.Icon != '' ? `<i class="` + action.Icon + `"></i>` : this._escapeHtml(this._getLayerActionLabel(action));
                    template += `<button type="button" action-id="` + action.Id + `" title="` + this._escapeHtml(title) + `" class="mr-1 normal-layer-option legend-toggle-option btn btn-primary xp-control-action-group-button xp-control-action-has-menu xp-map-layer-action-group-button action-button-` + layer.Id + ` contextualJs">` + content + `</button>`;
                } else if (action.SubType != 'ADD_MULTI' && action.SubType != 'STATISTICS') {
                    template += `<span action-id="` + action.Id + `" title="` + action.Title + `" class="mr-1 ` + action.Icon + ` normal-layer-option legend-toggle-option btn btn-primary action-button-` + layer.Id + `"></span>`;
                }
            });
        }

        return template;
    }

    _getLayerGeneralAction(layer) {
        let generalActionSettings = this.mapControl.generalActionSettingsHandler.settings;

        return generalActionSettings.filter(x => x.IdMapLayer == layer.Id);
    }

    _getLegendLayerPreview(layer) {
        let template = ``;

        if (layer.Id == layerTypes.MEASUREMENTS) {
            template = `<span class="fal fa-ruler legend-preview-icon" style="font-size: 0.9rem;"></span>`;
        }
        else if (layer.Id == layerTypes.DIMENSIONING) {
            template = `<span class="fal fa-arrows-h legend-preview-icon" style="font-size: 0.9rem;"></span>`;
        }
        else if (layer.Id == layerTypes.REDLINE) {
            template = `<span class="fal fa-pencil-paintbrush legend-preview-icon" style="font-size: 0.9rem;"></span>`;
        }
        else if (layer.Type == layerTypes.GRATICULE) {
            template = `<span class="fal fa-border-all legend-preview-icon" style="font-size: 0.9rem;"></span>`;
        }
        else if (layer.Type == layerTypes.GROUP) {
            template = `<span class="fal fa-object-group legend-preview-icon"></span>`;
        } else if (layer.Type == layerTypes.GEOSERVICE) {
            if (layer.Geoservice.LegendUrl != null && layer.Geoservice.LegendUrl.trim() != '') {
                template = `<img class="legend-preview-image" src="` + (this.rootURL + paths.PROXY_URL + this.mapId + '/' + layer.Fid.replaceAll('-', '') + layer.Geoservice.LegendUrl) + `?cb=${Date.now()}` + `"></img>`;
            } else {
                template = `<span class="fal fa-globe legend-preview-icon"></span>`;
            }
        }

        if (layer.IdDefaultStyle != null && layer.IdDefaultStyle > 0) {
            template = `<img class="legend-preview-image" src="` + (this.rootURL + paths.LAYER_PREVIEW_URL.replaceAll('{id}', layer.IdDefaultStyle).replaceAll('{rule}', 0)) + `?cb=${Date.now()}` + `"></img>`;
        }

        return template;
    }

    _getLegendClassificationLayerPreview(layer, classification) {
        // clasele variaza dupa date (cuantile/jenks/categorial) => desenam pastila din culoarea live,
        // nu din PNG-ul generat la salvarea stilului
        if (classification.color != null && classification.color !== '') {
            return `<span class="legend-preview-swatch" style="background-color: ` + classification.color + `;"></span>`;
        }

        return `<img class="legend-preview-image" src="` + (this.rootURL + paths.LAYER_PREVIEW_URL.replaceAll('{id}', layer.IdDefaultStyle).replaceAll('{rule}', classification.idx)) + `?cb=${Date.now()}` + `"></img>`;
    }

    _notifyVisibility(visible) {
        $event.notify(eventTypes.LEGEND_VISIBILITY_CHANGED, { visible: visible }, this, this.classId);
    }

    _getLegendTemplate() {
        let div = document.createElement('div');
        div.innerHTML = `<div class="modal-legend" id="` + this.legendElementId + `">
                            <div class="modal-legend-resizer" id="` + this.legendResizerElementId + `"></div>
                            <div class="modal-legend-header border-faded border-bottom-1 d-flex justify-content-left align-items-center pl-4">
                                <h4 class="m-0 text-center">` + this.resourcesHandler.get('Legend') + `</h4>
                                <button id="` + this.legendCloseElementId + `" type="button" class="close position-absolute pos-top pos-right p-2 m-1 mr-2" title="` + this.resourcesHandler.get('Close') + `">
                                    <span aria-hidden="true"><i class="fal fa-times"></i></span>
                                </button>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-12 pt-2 pl-3 pr-3 d-inline-flex" id="` + this.legendSearchWrapperElementId + `">
                                    <input id="` + this.legendSearchInputElementId + `" type="text" placeholder="` + this.resourcesHandler.get('Search') + `" class="form-control"></input>
                                </div>
                            </div>
                            <div class="modal-legend-body ml-2 mr-2">
                                <div class="map-legend-wrapper" id="` + this.legendContentWrapperElementId + `">
                                </div>
                            </div>
                        </div>`;

        return div.firstChild;
    }

    _getModalTemplate() {
        let div = document.createElement('div');
        div.innerHTML = `<div class="legend-modal-helper" id="` + this.legendModalHelper + `">
                        </div>`;
        return div.firstChild;
    }

    _getExtraModalTemplate() {
        let div = document.createElement('div');
        div.innerHTML = `<div class="legend-extra-modal-helper" id="` + this.legendExtraModalHelper + `">
                        </div>`;
        return div.firstChild;
    }

    _getFilterModalTemplate() {
        let div = document.createElement('div');
        div.innerHTML = `<div class="legend-extra-modal-helper" id="` + this.legendFilterModalHelper + `">
                        </div>`;
        return div.firstChild;
    }

    _getActionButtonTemplate() {
        let div = document.createElement('div');
        div.innerHTML = `<li>
                            <a class="btn map-menu-item" id="` + this.elementId + `" title="` + this._getTitle() + `">
                                <i class="` + this.action.Icon + `"></i>
                            </a>
                        </li>`;
        return div.firstChild;
    }

    _getStyleSettingsTemplate(layer) {
        return `<div class="form-row mb-0 style-config-row">
                    <div class="style-config-item" id="` + this.defaultStyleId + layer.Id + `">
                        <label class="form-label map-style-label">` + this.resourcesHandler.get('DefaultStyle') + `
                            <span title="` + this.resourcesHandler.get('EditStyle') + `" class="fal fa-pencil-alt btn btn-primary switch-style-btn" id="` + this.editDefaultStyle + layer.Id + `"></span>
                        </label>
                        <div class="style-config-img-wrapper mt-1">
                        </div>
                    </div>
                    <div class="style-config-item" id="` + this.highlightStyleId + layer.Id + `">
                        <label class="form-label map-style-label">` + this.resourcesHandler.get('HighlightStyle') + `
                            <span title="` + this.resourcesHandler.get('EditStyle') + `" class="fal fa-pencil-alt btn btn-primary switch-style-btn" id="` + this.editHighlightStyle + layer.Id + `"></span>
                        </label>
                        <div class="style-config-img-wrapper mt-1">
                        </div>
                    </div>
                    <div class="style-config-item" id="` + this.selectStyleId + layer.Id + `">
                        <label class="form-label map-style-label">` + this.resourcesHandler.get('SelectStyle') + `
                            <span title="` + this.resourcesHandler.get('EditStyle') + `" class="fal fa-pencil-alt btn btn-primary switch-style-btn" id="` + this.editSelectStyle + layer.Id + `"></span>
                        </label>
                        <div class="style-config-img-wrapper mt-1">
                        </div>
                    </div>
                </div>`;
    }

    _getStyleSwitcherTemplate() {
        return `<div class="general-settings-wrapper panel config-modal" id="` + this.styleSwitcherWrapper + `">
                    <div class="general-settings-panel panel-container">
                        <div class="panel-content pt-2 pl-0 pr-0 pb-0">
                            <div class="form-row general-settings-title-row m-0">
                                <label class="form-label general-settings-title ml-3">` + this.resourcesHandler.get('ChooseStyle') + `</label>
                            </div>
                            <div class="form-row mb-0" id="` + this.styleSwitcherContainer + `">
                            </div>
                        </div>
                        <div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right">
                            <button id="` + this.cancelStyleSwitchId + `" class="btn btn-secondary ml-auto" title="` + this.resourcesHandler.get('CancelChanges') + `" type="button">` + this.resourcesHandler.get('Cancel') + `</button>
                        </div>
                    </div>
                </div>`;
    }

    _getStyleEditTemplate(type) {
        return `<div class="general-settings-wrapper panel config-modal" id="` + this.styleEditWrapper + `">
                    <div class="general-settings-panel panel-container">
                        <div class="panel-content pt-2 pl-0 pr-0 pb-0">
                            <div class="form-row general-settings-title-row m-0">
                                <label class="form-label general-settings-title ml-3">` + this.resourcesHandler.get('EditStyle') + ` ` + this.resourcesHandler.get(type) + `</label>
                            </div>
                            <div class="form-row mb-0 pl-3 pr-3 pt-3" id="` + this.styleEditContainer + `">
                            </div>
                        </div>
                        <div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right">
                            <button id="` + this.cancelStyleEditId + `" class="btn btn-secondary ml-auto" title="` + this.resourcesHandler.get('CancelChanges') + `" type="button">` + this.resourcesHandler.get('Cancel') + `</button>
                            <button id="` + this.applyStyleEditId + `" class="btn btn-primary ml-2" title="` + this.resourcesHandler.get('SaveChanges') + `" type="button">` + this.resourcesHandler.get('Save') + `</button>
                        </div>
                    </div>
                </div>`;
    }
}
